export default {
  SHOW_TOAST: 'APP_SHOW_TOAST',
};
